import { HallowAnalyticsEvent } from "@packages/analytics";

const regexEscape = (str: string): string => {
  return str?.replaceAll(/[.*+?^${}()|[\]\\]/g, "\\$&") ?? ""; // $& means the whole matched string
};

export const UNIVERSITY_NAMES = {
  "notre-dame": "Notre Dame",
};

export const UNIVERSITY_EMAIL_DOMAINS = {
  "notre-dame": "@nd.edu",
};

export const UNIVERSITY_HEADERS = {
  "notre-dame": "register_screen_welcome_notre_dame",
};

export const UNIVERSITY_EVENTS = {
  "notre-dame-view": HallowAnalyticsEvent.ViewedNotreDameRegister,
  "notre-dame-submit": HallowAnalyticsEvent.SubmittedNotreDameForm,
  "notre-dame-captcha": HallowAnalyticsEvent.VerifiedNotreDameCaptcha,
  "notre-dame-create": HallowAnalyticsEvent.CreatedNotreDameEmailAccount,
  "notre-dame-subscribe": HallowAnalyticsEvent.SubscribedNotreDameUser,
};

export const customValidator = (emailDomain: "^@[w.]+$") =>
  new RegExp(`^\\S+${regexEscape(emailDomain)}$`);
